export enum UserPages {
  INFORMATION = "information",
  ASSETS = "assets",
  DOCUMENTS = "documents",
  EXTERNAL_BOOKKEEPING = "external-bookkeeping",
  RECEIPTS = "receipts",
  DATEV_IMPORT = "datev-import",
  ANSCHREIBEN = "anschreiben",
}
